import { EmptyCity, EmptySkill } from "../dashboard/dashboard";
import { useState } from "react";
import { MdAddCircleOutline } from "react-icons/md";
import { AiFillCloseCircle, AiFillStar, AiOutlineClose } from "react-icons/ai";
import { Observer } from "mobx-react";
import Experience from "./Experience";
import { useStores } from "../../store";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HelpCenter from "../reusble_components/helpCenter";

export default function CareerDetails() {
  const [pay, setpay] = useState(false);
  const [skills, setSkills] = useState([]);
  const [prefferedLocation, setPrefferedLocation] = useState([]);
  const [city, setCity] = useState("");
  const [showCity, setShowCity] = useState(false);
  const [showSkills, setShowSkills] = useState(false);
  const [skill, setSkill] = useState("");
  const [experience, setExperience] = useState([]);
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("free");
  const { CommonStore } = useStores();
  const [intern, setIntern] = useState(false);
  const [Tech, setTech] = useState("");
  const technology = [
    {
      name: "UI UX",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/UI-UX.png",
    },
    {
      name: "React",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/REACT.png",
    },
    {
      name: "React Native",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/REACT.png",
    },
    {
      name: "Node Js",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/NODE%20JS.png",
    },
    {
      name: "Mern",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/becomeamernstackdeveloper-mobile-300x279.png",
    },
    {
      name: "Flutter",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/1.png",
    },
    {
      name: "AWS-Devops",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/download (2).jpeg",
    },
    {
      name: "Azure-devops",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/1_iemC2V8xo9cuWpcrw5cewg.webp",
    },
    {
      name: "Marketing",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/360_F_228184808_BwcnbLZRuqThsuWqDtx8dJRM6CmfLkHN.jpg",
    },
    {
      name: "Sales",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/sales-vector-icon-logo-design-193477234.webp",
    },
    {
      name: "Digital Marketing",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/images.jpeg",
    },
    {
      name: "Sales Force",
      url: "https://reaidystorage.blob.core.windows.net/spotmiespublic/sales-force.png",
    },
  ];

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const [workTypes, setWorkTypes] = useState([]);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    // If checked, add the value to the array, otherwise remove it
    if (checked) {
      setWorkTypes([...workTypes, value]);
    } else {
      setWorkTypes(workTypes.filter((type) => type !== value));
    }
  };
  const AutoFill = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    document.getElementById("link").value = user?.linkedIn;
    document.getElementById("github").value = user?.gitHub;
    setPrefferedLocation(user?.cityPreference);
    if (user.cityPreference.length > 0) {
      setShowCity(true);
    }
    setSkills(user.skills);
    if (user.skills.length > 0) {
      setShowSkills(true);
    }
    setWorkTypes(user.workPreference);
    document.getElementById("stipend").value = user?.expectedSalary;
    document.getElementById("job").checked = user?.lookingFor === "job";
    document.getElementById("internship").checked =
      user?.lookingFor === "Internship";
    if (user.lookingFor === "Internship") {
      setpay(true);
      setIntern(true);
    }

    UserStore.setUserExperience(user?.previousCompanies);
    // setExperience(user.previousCompanies);
  };

  const { PopupStore, UserStore } = useStores();
  useEffect(() => {
    UserStore?.userexperience && setExperience(UserStore?.userexperience);
  }, [UserStore?.userexperience]);
  const addSkills = () => {
    setShowSkills(true);
    if (!skill) return alert("Please enter a skill");

    if (skill) {
      setSkills([...skills, skill]);
      setSkill("");
    }
  };

  const removeSkill = (skill) => {
    setSkills(skills.filter((item) => item !== skill));
  };

  const addcity = () => {
    setShowCity(true);

    if (city) {
      setPrefferedLocation([...prefferedLocation, city]);
      setCity("");
    } else {
      alert("Please enter a city");
    }
  };

  const removeCity = (city) => {
    setPrefferedLocation(prefferedLocation.filter((item) => item !== city));
  };

  return (
    <Observer>
      {() => (
        <>
          {PopupStore.experience && (
            <Experience
              popUpInitialValue={PopupStore.experience}
              handlePopup={() => {
                PopupStore.setExperience(false);
                UserStore?.userexperience &&
                  setExperience(UserStore?.userexperience);
              }}
            />
          )}
          <HelpCenter />
          <div className="py-10 md:py-0 mt-28 md:mt-10 px-5 my-12 md:my-0">
            <div className="flex justify-between items-center">
              <p className="text-primary text-lg md:text-2xl font-bold md:py-3 px-10">
                Enter Details
              </p>
              <div className="bg-primary rounded-lg mr-10">
                <p
                  onClick={AutoFill}
                  className="text-white p-3 flex justify-center items-center gap-2  cursor-pointer "
                >
                  <AiFillStar /> Auto fill{" "}
                </p>
              </div>
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (skills.length === 0) {
                  alert("Please add skills");
                  return;
                }
                if (Tech === "") {
                  alert("Please select a job role");
                  return;
                }
                if (prefferedLocation.length === 0) {
                  alert("Please add preffered location");
                  return;
                }
                const workType = workTypes.filter((item) => item !== "Hybrid");

                const body = {
                  linkedIn: e.target.link.value,
                  gitHub: e.target.github.value,
                  skills: skills,
                  previousCompanies: experience,
                  lookingFor: e.target.selection.value,
                  openForFreeInternship:
                    selectedOption === "free" ? true : false,
                  internshipDurationPreference:
                    e.target.internshipPeriod?.value,
                  workPreference: workType,
                  cityPreference: prefferedLocation,
                  expectedSalary: e.target.stipend.value,
                };
                console.log(body);
                localStorage.setItem("career", JSON.stringify(body));
                navigate(`/dashboard/career-info/${Tech}`);
                CommonStore.setBottomNavigationIndex(10);
              }}
            >
              <div className="md:grid md:grid-cols-3 gap-4 md:p-3 p-1 lg:text-xl">
                <label
                  className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
                  htmlFor="link"
                >
                  <span className="lg:pb-2 font-bold">
                    Linkedin / behance URL
                  </span>
                  <input
                    type="text"
                    name="link"
                    id="link"
                    required
                    className="border rounded-lg border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16 "
                  />
                </label>
                <label
                  className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
                  htmlFor="github"
                >
                  <span className="lg:pb-2 font-bold">Github Profile URL</span>
                  <input
                    type="text"
                    name="github"
                    id="github"
                    required
                    className="border rounded-lg  border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16"
                  />
                </label>

                <label className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <span className="flex justify-between">
                    <span className="lg:pb-2 font-bold">Skills you have</span>
                    {/* <span
                      onClick={addSkills}
                      type="button"
                      className="flex items-center w-24 h-8 cursor-pointer space-x-1 text-primary"
                    >
                      <MdAddCircleOutline />
                      <span className="lg:pb-2">Add Skill</span>
                    </span> */}
                  </span>
                  <div className="flex flex-row border rounded-lg border-text_color5 justify-between items-center">
                    <input
                      type="text"
                      name="skill"
                      id="skill"
                      className="w-full p-3 rounded-lg  focus:outline-none h-10 text-gray-500  lg:h-14"
                      value={skill}
                      onChange={(e) => setSkill(e.target.value)}
                      // onKeyPress={(e) => {
                      //   if (e.key === "Enter") {
                      //     addSkills();
                      //   }
                      // }}
                    />
                    <span
                      onClick={addSkills}
                      type="button"
                      className=" w-8  cursor-pointer p-2 text-primary"
                    >
                      <MdAddCircleOutline />
                    </span>
                  </div>
                  {skills.length === 0 ? (
                    <>
                      <EmptySkill />
                    </>
                  ) : (
                    <>
                      {showSkills && (
                        <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
                          {skills.map((skill, index) => (
                            <div
                              className="flex relative flex-row justify-end pt-2"
                              key={index}
                            >
                              {/* <div className=" cursor-pointer absolute w-4 h-4 text-xs text-bg3 text-center rounded-full mx-1 my-1 bg-text_color3" onClick={() => { removeSkill(skill) }}>x</div> */}
                              <AiFillCloseCircle
                                className="absolute cursor-pointer md:my-0 lg:my-0 mb-2 mr-[5px]"
                                onClick={() => {
                                  removeSkill(skill);
                                }}
                              />
                              <p className="text-[15px] lg:text-xl lg:p-4 lg:px-8 lg:rounded-xl  rounded-lg  bg-primary  text-bg3 py-1 px-4 mr-2">
                                {skill}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </label>

                <label className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <span className="flex justify-between w-[80vw] md:w-[52vw]">
                    <span className="lg:pb-2 font-bold">
                      Previous Experience
                    </span>
                    <span
                      type="button"
                      className="flex items-center w-24 h-8 cursor-pointer space-x-1 text-primary lg:w-32"
                      onClick={() => {
                        PopupStore.setExperience(true);
                      }}
                    >
                      <MdAddCircleOutline />
                      <span>Add New</span>
                    </span>
                  </span>
                  <div className="flex flex-col  border rounded-lg border-text_color5 w-[80vw] md:w-[52vw] h-16  overflow-y-auto">
                    {experience.map((exp, index) => (
                      <div key={index} className="flex flex-col">
                        <span className="flex flex-row justify-between items-center px-4 ">
                          <p className=" ">
                            {" "}
                            {exp.company} {exp.designation}{" "}
                          </p>
                          <small>
                            {exp.joiningDate} - {exp.completionDate}
                          </small>
                        </span>
                      </div>
                    ))}
                  </div>
                </label>
              </div>
              <label className="px-3 md:px-8 lg:mx-5 flex flex-row gap-6 items-center">
                <span className="font-bold text-lg lg:text-xl">Select one</span>
                <div className="mt-1">
                  <input
                    type="radio"
                    id="job"
                    name="selection"
                    value="job"
                    className="mr-2 "
                    onChange={(e) => {
                      setpay(false);
                    }}
                    required
                  />
                  <label htmlFor="job" className="text-gray-500">
                    Job
                  </label>

                  <input
                    type="radio"
                    id="internship"
                    name="selection"
                    value="internship"
                    onChange={(e) => {
                      setpay(true);
                      setIntern(true);
                    }}
                    className="ml-8 mr-2"
                    required
                  />
                  <label htmlFor="internship" className="text-gray-500">
                    Internship
                  </label>
                </div>
              </label>
              <div className="md:grid md:grid-cols-3 gap-4 md:p-3 lg:text-xl">
                {pay && (
                  <label
                    className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
                    htmlFor="salarytype"
                  >
                    <span className="lg:pb-2 font-bold">Select free/paid</span>
                    <select
                      name="salarytype"
                      id="salarytype"
                      required
                      className="border border-text_color5 p-2 rounded-lg mt-1 h-10 text-gray-500 lg:h-16"
                      value={selectedOption}
                      onChange={handleChange}
                    >
                      <option value="free">Free</option>
                      <option value="paid">Paid</option>
                    </select>
                    {selectedOption === "paid" && (
                      <div className="text-yellow ">
                        We recommend choosing the "free" option to increase your
                        chances of being hired promptly.
                      </div>
                    )}
                  </label>
                )}
                {pay && (
                  <label
                    className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
                    htmlFor="salarytype"
                  >
                    <span className="lg:pb-2 font-bold">
                      Internship Duration
                    </span>
                    <input
                      type="number"
                      name="internshipPeriod"
                      id="internshipPeriod"
                      className="w-full p-3 rounded-lg border border-text_color5 focus:outline-none h-10 text-gray-500  lg:h-16"
                      placeholder="Enter number of months"

                      // onKeyPress={(e) => {
                      //   if (e.key === "Enter") {
                      //     addSkills();
                      //   }
                      // }}
                    />
                    {/* {selectedOption === "" && ( */}
                    <div className="text-yellow ">
                      Please enter the number of months you are looking for an
                      internship.
                    </div>
                    {/* )} */}
                  </label>
                )}

                {/* <label
                  className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
                  htmlFor="workType"
                >
                  <span className="lg:pb-2">Select work type</span>
                  <select
                    name="workType"
                    id="workType"
                    required
                    className="border border-text_color5 p-2 mt-1 h-10 text-gray-500 lg:h-16"
                  >
                    <option value="workFromOffice">WFO</option>
                    <option value="workFromHome">WFH</option>

                    <option value="hybrid">Hybrid</option>
                  </select>
                </label> */}

                <label className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <span className="flex justify-between">
                    <span className="lg:pb-2 font-bold lg:text-xl">
                      Preffered Location
                    </span>
                    {/* <span
                      onClick={addcity}
                      type="button"
                      className="flex items-center w-24 h-8 cursor-pointer space-x-1 text-primary"
                    >
                      <MdAddCircleOutline />
                      <span className="lg:pb-2">Add City</span>
                    </span> */}
                  </span>
                  <div className="flex flex-row border rounded-lg border-text_color5 justify-between items-center">
                    <input
                      type="text"
                      name="city"
                      id="city"
                      className="w-full p-3 rounded-lg focus:outline-none h-10 text-gray-500  lg:h-16 lg:text-xl"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                    <span
                      onClick={addcity}
                      type="button"
                      className=" w-8  cursor-pointer p-2 text-primary"
                    >
                      <MdAddCircleOutline />
                    </span>
                  </div>
                  {prefferedLocation.length === 0 ? (
                    <>
                      <EmptyCity />
                    </>
                  ) : (
                    <>
                      {showCity && (
                        <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
                          {prefferedLocation.map((city, index) => (
                            <div
                              className="flex relative flex-row justify-end pt-2"
                              key={index}
                            >
                              {/* <div className=" cursor-pointer absolute w-4 h-4 text-xs text-bg3 text-center rounded-full mx-1 my-1 bg-text_color3" onClick={() => { removeSkill(skill) }}>x</div> */}

                              <p className="text-[15px] lg:text-xl lg:p-4 lg:px-8 lg:rounded-xl flex items-center gap-2  rounded-lg  bg-primary  text-bg3 py-1 px-4 mr-2">
                                {city}{" "}
                                <AiOutlineClose
                                  className="text-white cursor-pointer"
                                  onClick={() => {
                                    removeCity(city);
                                  }}
                                />
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </label>

                <label className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <span className="flex justify-between">
                    <span className="lg:pb-2 font-bold lg:text-xl">
                      Salary / Stipend expecting{" "}
                    </span>
                  </span>
                  <div className="flex flex-row">
                    <input
                      type="number"
                      name="stipend"
                      id="stipend"
                      required
                      className="w-full p-3 rounded-lg border border-text_color5 focus:outline-none h-10 text-gray-500  lg:h-16 lg:text-xl"
                      {...(selectedOption === "free" &&
                        intern && { defaultValue: 0 })}
                      // value={skills}
                    />
                  </div>
                </label>
              </div>
              <div className="mb-2 px-8  lg:w-[65%]">
                <label className="block mb-1 md:mt-2 ml-2  md:text-base lg:text-lg font-bold">
                  Work Type
                </label>
                <div className="flex flex-col">
                  <label htmlFor="wfh" className="mb-2 flex items-center">
                    <input
                      type="checkbox"
                      id="wfh"
                      name="workType"
                      value="workFromHome"
                      className="mr-2"
                      onChange={handleCheckboxChange}
                      checked={workTypes.includes("workFromHome")}
                    />
                    WFH (Work From Home)
                  </label>
                  <label htmlFor="hybrid" className="mb-2 flex items-center">
                    <input
                      type="checkbox"
                      id="hybrid"
                      name="workType"
                      value="hybrid"
                      className="mr-2"
                      onChange={handleCheckboxChange}
                      checked={workTypes.includes("hybrid")}
                    />
                    Hybrid
                  </label>
                  <label htmlFor="wfo" className="flex items-center">
                    <input
                      type="checkbox"
                      id="wfo"
                      name="workType"
                      value="workFromOffice"
                      className="mr-2"
                      onChange={handleCheckboxChange}
                      checked={workTypes.includes("workFromOffice")}
                    />
                    WFO (Work From Office)
                  </label>
                  {/* Display selected work types */}
                  {/* <p>Selected Work Types: {workTypes.join(", ")}</p> */}
                </div>
                <p className="py-4 text-lg pt-10 font-bold">
                  Select the job role
                </p>
                <div className="flex flex-wrap  gap-4">
                  {technology.map((tech, index) => (
                    <div
                      key={index}
                      className={`flex flex-row cursor-pointer border rounded-lg items-center h-14 px-4 ${
                        tech.name === Tech ? "border-primary" : ""
                      }`}
                      onClick={() => {
                        setTech(tech.name);
                      }}
                    >
                      <img
                        src={tech.url}
                        alt={tech.name}
                        className="w-10 h-10"
                      />
                      <p>{tech.name}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="p-8">
                <button
                  type="submit"
                  className="bg-primary text-white w-72 md:py-4 text-lg px-3 py-2 rounded-xl "
                >
                  Take an Interview
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </Observer>
  );
}
